import React, { useEffect } from 'react';
import { Label } from '@/components/ui/label';

const STATES = ['NSW', 'VIC', 'QLD', 'SA', 'WA', 'TAS', 'NT', 'ACT'];

export default function TurnoverSplitField({ value, onChange, homeState, basis = 'turnover' }) {
  const home = String(homeState || '').toUpperCase();
  const isGaraging = basis === 'garaging';
  useEffect(() => {
    if (!value && STATES.includes(home)) onChange({ [home]: 100 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [home]);

  const split = value || (STATES.includes(home) ? { [home]: 100 } : {});
  const total = Object.values(split).reduce((s, v) => s + (parseFloat(v) || 0), 0);
  const ok = Math.abs(total - 100) < 0.01;

  const set = (st, v) => {
    const next = { ...split };
    const pct = parseFloat(v);
    if (!pct) delete next[st]; else next[st] = pct;
    onChange(next);
  };

  return (
    <div data-testid="turnover-split-field">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <Label className="text-xs" style={{ color: '#5C6B7A' }}>
          {isGaraging ? 'Fleet garaged by State & Territory (%)' : 'Turnover by State & Territory (%)'}
        </Label>
        <span data-testid="turnover-split-total" className="text-[11px] font-mono px-2 py-0.5 rounded"
          style={{ background: ok ? 'rgba(29,158,117,0.1)' : 'rgba(226,75,74,0.1)', color: ok ? '#1D9E75' : '#B03230' }}>
          {Math.round(total * 100) / 100}% {ok ? '✓' : '— must total 100%'}
        </span>
      </div>
      <p className="text-[11px] mt-1" style={{ color: '#5C6B7A' }}>
        {isGaraging
          ? 'Motor duty follows where each vehicle is garaged overnight, not the head office. Enter the share of fleet value garaged in each jurisdiction — ACT-garaged vehicles pay no duty.'
          : "Stamp duty is apportioned to each State's revenue office on this split — rates differ by jurisdiction (ACT charges none). Defaults to the client's home state; correct it if turnover is earned elsewhere."}
      </p>
      <div className="grid grid-cols-4 md:grid-cols-8 gap-2 mt-2">
        {STATES.map(st => (
          <div key={st}>
            <span className="text-[10px] font-semibold uppercase tracking-wider" style={{ color: '#5C6B7A' }}>{st}</span>
            <input type="number" min="0" max="100" step="0.1" value={split[st] ?? ''} placeholder="0"
              onChange={e => set(st, e.target.value)} data-testid={`turnover-split-${st.toLowerCase()}`}
              className="mt-0.5 w-full px-2 py-1.5 border border-input rounded-sm text-sm bg-white" />
          </div>
        ))}
      </div>
    </div>
  );
}
